import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

//internal deps
import { GridContainer } from "@swiggy-private/dls-web-core/dist/components/GridContainer";

//types
import { ISpacing } from "@swiggy-private/dls-web-common/dist/components/types";

//components
import CarouselItem from "../CarouselItem/CarouselItem";

import { CarouselWrapper, DotIndicator, DotWrapper, Wrapper } from "./styles";
import { CollectionProps, GridType, MerchCarouselProps, WIDGET_IDS } from "@swiggy-private/checkout-types";
import { CAROUSEL_DIMENTIONS, CAROUSEL_TIMINGS } from "@dineout-payment-success-ui/constants/Constants";
import { getGridConfig, getGridLayout } from "@dineout-payment-success-ui/utils/Utils";
import { useTheme } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider/use-theme";

function MerchCarousel(props: MerchCarouselProps) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerReady, setContainerReady] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (containerRef.current) {
            setContainerReady(true);
        }
    }, [containerRef]);

    const { gridElements, layout, screenName, isCalloutExists } = props;
    const { infoWithStyle } = gridElements;
    const { style } = infoWithStyle;

    const onViewedItem = (data: any) => {
        setActiveIndex(data?.index);
    };
    const { spacing } = useTheme();

    const { itemSpacing } = useMemo(() => getGridConfig(layout, spacing), [layout]);
    const carouselLayout = useMemo(() => getGridLayout(layout, infoWithStyle.info), [layout, infoWithStyle]);

    const getColumns = useCallback(
        (items: CollectionProps[]) => ({
            columns: items?.map((collection, index) => (
                <CarouselItem
                    key={index}
                    {...collection}
                    screenName={screenName}
                    onViewItem={onViewedItem}
                    index={index}
                    style={style}
                />
            )),
        }),
        [screenName],
    );

    const items = useMemo(
        () => ({
            rows: carouselLayout.map(getColumns),
        }),
        [carouselLayout, containerReady, getColumns],
    );

    return (
        <Wrapper isCalloutExists={isCalloutExists} data-testid={WIDGET_IDS.MERCH_CAROUSEL}>
            <>
                <CarouselWrapper>
                    <GridContainer
                        items={items}
                        interItemSpacing={itemSpacing as keyof ISpacing}
                        scrollableContainerRef={containerRef}
                        gridType={GridType.CAROUSEL}
                        background="none"
                        carouselConfig={{
                            scrollTime: CAROUSEL_TIMINGS.scrollTime,
                            autoScrollDelay: CAROUSEL_TIMINGS.autoScrollDelay,
                        }}
                        itemWidth={CAROUSEL_DIMENTIONS.itemWidth}
                        title={""}
                    />
                </CarouselWrapper>
                <DotWrapper>
                    {infoWithStyle?.info?.map((_element, index) => (
                        <DotIndicator key={index} isActive={index === activeIndex} />
                    ))}
                </DotWrapper>
            </>
        </Wrapper>
    );
}

export default memo(MerchCarousel);
